import { create } from 'zustand';
import { storage } from '../utils/platform';
import { signalRService } from '../utils/signalr/signalRService';
import { useConnectionStore } from './connectionStore';
import { useFriendStore } from './friendStore';
import { useGameFlowStore } from './gameFlowStore';
import { useGameSessionStore } from './gameSessionStore';

export interface UserInfo {
  id: number;
  uid: string;
  name: string;
  friendID: string;
  photo: string;
  loginType: number;
  totalBalance: number;
  diamond: number;
  isVIP: boolean;
  isForeverVIP: boolean;
  vipStartDate?: Date;
  vipEndDate?: Date;
  gameCount: number;
  tradeCount: number;
  tradeWinCount: number;
  totalProfitLoss: number;
  winRate: number;
  userStockCount?: number;
  allreadyDailyLogin?: boolean;
}

interface AuthState {
  user: UserInfo | null;
  unreadInboxCount: number;
  isAuthenticated: boolean;

  setUser: (user: UserInfo | null) => void;
  setUnreadInboxCount: (count: number) => void;
  updateBalance: (partial: Pick<UserInfo, 'totalBalance' | 'diamond'>) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  unreadInboxCount: 0,
  isAuthenticated: false,

  setUser: (user) =>
    set({
      user,
      isAuthenticated: user != null,
    }),

  setUnreadInboxCount: (count) => set({ unreadInboxCount: count }),

  updateBalance: (partial) => {
    const { user } = get();
    if (!user) return;
    set({ user: { ...user, ...partial } });
  },

  logout: async () => {
    await signalRService.invoke('UserOffline').catch(() => {});
    await signalRService.stop();
    await storage.removeItem('token');

    useConnectionStore.getState().reset();
    useGameFlowStore.getState().resetToIdle();
    useGameSessionStore.getState().reset();
    useFriendStore.getState().reset();

    set({ user: null, unreadInboxCount: 0, isAuthenticated: false });
  },
}));
